/**
 * Enum of all store ids. These stores are specific to the user interface.
 */
export enum StoreId {
  Application = 'application',
  Appointments = 'appointments',
  Dashboard = 'dashboard',
  EmailTemplates = 'emailTemplates',
  Calendar = 'calendar',
  Import = 'import',
  Scheduler = 'scheduler',
  Settings = 'settings',
  Slots = 'slots',
  SnackBars = 'snackbars'
}
